// extracted by mini-css-extract-plugin
var _1 = "checkbox-kQc_f";
export { _1 as "checkbox" }
